import styled from 'styled-components';
import { Tooltip as AntdTooltip } from 'antd';

export const Tooltip = styled(AntdTooltip)`
  position: relative;
`;



// WEBPACK FOOTER //
// ./src/components/popovers/tooltip/style.js